/**
 * @generated SignedSource<<332297fe490791e38302a0c507e12f58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteContactDialog_contact$data = {
  readonly familyName?: string;
  readonly givenName?: string;
  readonly id: string;
  readonly teamName?: string;
  readonly " $fragmentType": "DeleteContactDialog_contact";
};
export type DeleteContactDialog_contact$key = {
  readonly " $data"?: DeleteContactDialog_contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteContactDialog_contact">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteContactDialog_contact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "givenName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "familyName",
          "storageKey": null
        }
      ],
      "type": "PersonContact",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "teamName",
          "storageKey": null
        }
      ],
      "type": "TeamContact",
      "abstractKey": null
    }
  ],
  "type": "Contact",
  "abstractKey": "__isContact"
};

(node as any).hash = "2043234d4412cf0e03f894c5eedf3a8f";

export default node;
